document.addEventListener('DOMContentLoaded', () => {

  /* — NAV — */
  const nav = document.querySelector('.site-nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* — HAMBURGER — */
  const burger = document.querySelector('.nav__burger');
  const drawer = document.querySelector('.nav__drawer');
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* — ANNOUNCE CLOSE — */
  const announceClose = document.querySelector('.announce__close');
  if (announceClose) {
    announceClose.addEventListener('click', () => {
      document.querySelector('.announce')?.remove();
    });
  }

  /* — STOCK BAR — */
  setTimeout(() => {
    const fill = document.querySelector('.hero__stock-fill');
    if (fill) fill.style.width = '73%';
  }, 500);

  /* — COUNT UP — */
  const countObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      const target = parseInt(el.dataset.count);
      if (!target) return;
      let start = 0;
      const step = target / (1200 / 16);
      const timer = setInterval(() => {
        start = Math.min(start + step, target);
        el.textContent = Math.round(start);
        if (start >= target) clearInterval(timer);
      }, 16);
      countObserver.unobserve(el);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('[data-count]').forEach(el => countObserver.observe(el));

  /* — REVEAL — */
  const revealObserver = new IntersectionObserver(entries => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('is-visible'), i * 50);
        revealObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.07, rootMargin: '0px 0px -32px 0px' });
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => revealObserver.observe(el));

  /* — FAQ — */
  window.toggleFaq = btn => {
    const item = btn.closest('.faq__item');
    const open = item.classList.contains('is-open');
    document.querySelectorAll('.faq__item').forEach(i => i.classList.remove('is-open'));
    if (!open) item.classList.add('is-open');
    btn.setAttribute('aria-expanded', !open);
  };

  /* — PRODUCT ACCORDION — */
  window.toggleAccordion = btn => {
    const item = btn.closest('.accordion-item');
    const open = item.classList.contains('is-open');
    document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('is-open'));
    if (!open) item.classList.add('is-open');
  };

  /* — GALLERY SWITCH — */
  window.switchGallery = (src, thumb) => {
    const main = document.querySelector('.gallery__main img');
    if (main) main.src = src;
    document.querySelectorAll('.gallery__thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  };

  /* — QUANTITY — */
  let qty = 1;
  window.changeQty = delta => {
    qty = Math.max(1, qty + delta);
    const el = document.getElementById('qty-display');
    const inp = document.getElementById('qty-input');
    if (el) el.textContent = qty;
    if (inp) inp.value = qty;
  };

  /* — VARIANT SELECT — */
  window.selectVariant = btn => {
    btn.closest('.product-variants__options')?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  };

  /* — PRODUCT STICKY — */
  const stickyBar = document.querySelector('.product-sticky');
  const primaryBtn = document.querySelector('.product-cta .btn--dark');
  if (stickyBar && primaryBtn) {
    new IntersectionObserver(entries => {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(primaryBtn);
  }

  /* — ADD TO CART — */
  const cartForm = document.getElementById('product-form');
  if (cartForm) {
    cartForm.addEventListener('submit', e => {
      e.preventDefault();
      const btn = cartForm.querySelector('[type=submit]');
      const originalText = btn.querySelector('span')?.textContent || btn.textContent;
      if (btn.querySelector('span')) btn.querySelector('span').textContent = '✓ Ajouté';
      else btn.textContent = '✓ Ajouté';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: cartForm.querySelector('[name=id]').value,
          quantity: qty
        })
      }).then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer?.open) cartDrawer.open();
      });
      setTimeout(() => {
        if (btn.querySelector('span')) btn.querySelector('span').textContent = originalText;
        else btn.textContent = originalText;
      }, 2500);
    });
  }

  /* — BUY NOW — */
  window.buyNow = e => {
    e.preventDefault();
    const id = document.querySelector('[name=id]')?.value;
    if (!id) return;
    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty })
      }))
      .then(() => window.location.href = '/checkout');
  };

  /* — SMOOTH ANCHOR SCROLL — */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* — PRODUCT CARD MOBILE TOUCH — */
  if ('ontouchstart' in window) {
    document.querySelectorAll('.product-card').forEach(card => {
      card.addEventListener('touchstart', () => {
        document.querySelectorAll('.product-card').forEach(c => c.classList.remove('is-touched'));
        card.classList.add('is-touched');
      }, { passive: true });
    });
  }

});